/**
 * @class EventManager
 * @description Listen to events on the page and manage it accross components.
 */
class EventManager {
  constructor(eventListeners) {
    this.eventListeners = eventListeners;
    this.events = {};
    this.attachListeners();
  }

  attachListeners() {
    if (this.eventListeners) {
      this.eventListeners.forEach(listener => {
        listener.target.addEventListener(listener.eventName, () => {
          if (!this.events[listener.eventName]) {
            this.events[this.getNodeName(listener.target) + listener.eventName] = {
              isTriggered: true
            };
          }
        });
      });
    }
  }

  getNodeName(target) {
    if (window.self === target) {
      return '';
    }
    if (target.nodeName) {
      return target.nodeName.toLowerCase() + '_';
    }
    return '';
  }

  isEventTriggered(eventName) {
    return this.events[eventName];
  }
}

module.exports = EventManager;



// WEBPACK FOOTER //
// ./src/rcs-orchestrator/utils/EventManager.js